<template>
  <div class="ly_modal_container" :style="{ width: '900px', zIndex }">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">소식 예문입력</h1>
    </div>
    <div class="ly_modal_content">
      <div :style="{marginBottom: '20px'}">
        <select v-model="selectedCategory">
          <option value>소식종류</option>
          <option
            v-for="category in sampleData"
            :value="category.name"
            :key="category.name"
          >{{ category.name }}</option>
        </select>
      </div>

      <ScrollTable
        :sourceList="tableItems"
        :scrollHeight="'500px'"
        :key="selectedCategory"
        ref="table"
      >
        <template #header>
          <caption>
            <span class="blind">맞춤소식 예문</span>
          </caption>
          <colgroup>
            <col width="20%" />
            <col />
            <col width="15%" />
          </colgroup>
          <thead class="table_list_head table_list_head_line">
            <tr>
              <th>소식종류</th>
              <th>예문</th>
              <th>입력</th>
            </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <fragment v-for="item in rowData.children" :key="`${rowData.name}${item}`">
            <tr>
              <td>{{rowData.name}}</td>
              <td class="left" v-html="$utils.nl2br(item)"></td>
              <td>
                <div class="btn_area type_fr">
                  <button type="button" class="reverse" @click="onClickItem(item)">입력</button>
                </div>
              </td>
            </tr>
          </fragment>
        </template>
      </ScrollTable>

      <div class="btn_area">
        <button type="button" class="btn_default" @click="close">닫기</button>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from "$mixins/popup";
import sampleData from "./RepeatContentSampleData.json";

export default {
  mixins: [popupMixin],
  props: {
    onSelected: Function
  },
  data() {
    return {
      selectedCategory: "",
      sampleData
    };
  },
  computed: {
    tableItems() {
      if (this.selectedCategory) {
        return [sampleData.find(cat => cat.name === this.selectedCategory)];
      } else {
        return sampleData;
      }
    }
  },
  methods: {
    onClickItem(content) {
      if (this.onSelected) this.onSelected(content);
      this.close();
    }
  }
};
</script>
